module.exports = __webpack_public_path__ + "img/luis-villasmil-mlVbMbxfWI4-unsplash.3e4b40f6.jpg";